import {Box} from '@mantine/core';
import type {FC} from 'react';
import {ClipConstants} from '../../../../core/entities/clip/constants';
import {ClipForMobileItem} from './ClipForMobileItem';
import type {ColorUtilProps} from './colorUtil';

type ClipTabProps = {
  pathname: ColorUtilProps['pathname'];
};

export const ClipTabForMobile: FC<ClipTabProps> = ({pathname}) => {
  return (
    <Box className="border-solid-2 border-b-[1px] border-background-3 bg-white py-16">
      <Box className="mx-auto my-0 table w-[90%] table-fixed">
        {Object.entries(ClipConstants.URL).map(([key, url]) => {
          return (
            <ClipForMobileItem
              key={key}
              keyName={key}
              url={url}
              pathname={pathname}
            />
          );
        })}
      </Box>
    </Box>
  );
};
